document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item')
      if (item) {
        item.classList.toggle('active')
      }
    })
  })

  document.querySelectorAll('product-gallery').forEach((gallery) => {
    const carousel = gallery.querySelector('.product-gallery__carousel')
    if (!carousel) return
    carousel.addEventListener('click', (e) => {
      if (window.matchMedia('(min-width: 1000px)').matches) return
      const media = e.target.closest('.product-gallery__media')
      if (!media || media.getAttribute('data-media-type') !== 'image') return
      const imageCells = Array.from(
        gallery.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden])')
      )
      const index = imageCells.indexOf(media)
      if (index >= 0) {
        gallery.dispatchEvent(
          new CustomEvent('lightbox:open', { bubbles: true, detail: { index } })
        )
      }
    })
  })
})


